//Core
import {AxiosResponse} from "axios";
//Service builder
import clientBuilder from "@/services/clientBuilder";
//Redux
import {store} from "@/redux/store";
import {endFetch, startFetch} from "@/redux/app/appSlice";
//Types
import {
    TGetAudienceResponse,
    TGetAudienceResponseData,
} from "@/types/services/audiences/response/getAudiencesResponseTypes";
import {TSaveAudienceRequest} from "@/types/services/audiences/request/saveAudienceRequestTypes";
import {
    TDefaultStatusResponse,
    TDefaultStatusResponseData,
} from "@/types/services/defaultResponse/defaultStatusResponseTypes";
import {
    TExportAudiencesRequest,
    TRequestStatus,
} from "@/types/services/audiences/request/exportAudiencesRequestTypes";
import {TGetAudiencesRequest} from "@/types/services/audiences/request/getAudiencesRequestTypes";
//Utils
import {fetchListItems} from "@/utils/fetchListItems";

const audienceClient = clientBuilder();

export const getAudiencesAPI = async (data: TGetAudiencesRequest) => {
    try {
        store.dispatch(startFetch(fetchListItems.getAudiences))
        const response: AxiosResponse<TGetAudienceResponse> = await audienceClient.post(`get_audiences`, data);
        if (response && response.data.errors === 0) return response.data.data as TGetAudienceResponseData;
        else return null;
    } catch (error) {
        console.log(error);
        return null;
    } finally {
        store.dispatch(endFetch(fetchListItems.getAudiences))
    }
};

export const saveAudienceAPI = async (data: TSaveAudienceRequest) => {
    try {
        store.dispatch(startFetch(fetchListItems.saveAudience))
        
        const response: AxiosResponse<TDefaultStatusResponse> = await audienceClient.put(`save_audience`, data);
        console.log(response);
        
        if (response && response.data.errors === 0) {
            return response.data.data as TDefaultStatusResponseData
        }
        else return null;
    } catch (error) {
        console.log(error);
        return null;
    } finally {
        store.dispatch(endFetch(fetchListItems.saveAudience))
    }
};

export const exportAudienceAPI = async (requestStatus?: TRequestStatus, email?: string) => {
    const isFromGeneralPage = store.getState().export.isFromGeneralPage;
    const payload: TExportAudiencesRequest = {
        user_id: store.getState().user.userId,
        twitter_id: store.getState().export.twitterId,
        user_email: email ?? store.getState().user.userData.email,
        request_status: requestStatus ?? "new",
        queries_id: isFromGeneralPage
            ? [store.getState().audience.queryId]
            : store.getState().audience.audiencesList
                .filter((el) => el.selected)
                .map((el) => el.query_id),
    };

    try {
        store.dispatch(startFetch(fetchListItems.exportAudience))
        const response: AxiosResponse<TDefaultStatusResponse> = await audienceClient.post(`export_audience`, payload);
        if (response && response.data.errors === 0) return response.data.data as TDefaultStatusResponseData;
        else return null;
    } catch (error) {
        console.log(error);
        return null;
    } finally {
        store.dispatch(endFetch(fetchListItems.exportAudience))
    }
};
